<template>
  <AppIcon icon="mdi:star" color="#EFAF19" size="large" />
</template>